import React from 'react';
import PlatformSteps from './components/PlatformSteps';
import './setting.less';

const Setting = ({ activeKey }) => {
  return <PlatformSteps activeKey={activeKey} />;
};

export default Setting;
